export default "__VITE_ASSET__n3$IXs5a__"